<template>
  <div >
    <v-card max-width="90%" class="mt-12 mx-auto">
      <v-card-title class="title-center" style="color: #59065d;">
        <i class="mr-2 fa fa-user-circle" />
        {{ name }}
      </v-card-title>
      <v-row class="text-center">
        <v-col>
          <v-card-text>
            <i class="fa fa-user-circle" style="color: #59065d;" />
            Account Number :
            <b>{{ accountNo }}</b>
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>Mobile Number: <b>{{ mobile }}</b></v-card-text>
        </v-col>
        <v-col>
          <v-card-text>Email: <b>{{ email }} </b></v-card-text>
        </v-col>
      </v-row>

      <v-row class="text-center">
        <v-col>
          <v-card-text>
            <v-icon class="mr-1" style=" color: #59065d">mdi-cash</v-icon>Monthly Cost
          </v-card-text>
          <v-card-text>
            <span class="rupee">&#8377;</span>
            <b>{{ $toFixed(monthlyCost) }}</b>
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <v-icon class="mr-1" style=" color: #59065d">mdi-cash</v-icon>Current Balance
          </v-card-text>

          <v-card-text>
            <span class="rupee">&#8377;</span>
            <b>{{ walletBalance }}</b>
          </v-card-text>
        </v-col>
        <v-col>
          <v-card-text>
            <v-icon class="mr-1" style=" color: #59065d">mdi-origin</v-icon>Pack Expiry
          </v-card-text>
          <v-card-text>
            <b v-text="basePackExpiry"></b>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card-title><v-icon class="mr-1" style=" color: #59065d">mdi-details</v-icon>Monthly Cost
          Hardware Details</v-card-title>

          <v-card-text>
            <h5>Set Top Box Number</h5>
            {{ serialNo }}
          </v-card-text>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-row justify="center" class="mb-4">
          <router-link to="/edit-profile">
            <v-btn class="login mr-2 ml-2 mb-2" rounded outlined color="primary">
              <v-icon left>mdi-pencil</v-icon>Edit Profile
            </v-btn>
          </router-link>
          <router-link to="/change-password">
          <v-btn class="login" outlined rounded color="primary">
            <v-icon left>mdi-atom-variant</v-icon>Change Password
          </v-btn>
          </router-link>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-card max-width="90%" class="mt-12 mx-auto">
      <v-card-title class="title-center" style="color: #59065d;">
        <i class="mr-2 fa fa-user-circle" />
        KYC
      </v-card-title>
      
      <v-card-title class="justify-center">
        No Documents Have Been Added 
      </v-card-title>
      <v-card-text class="text-center">
      <v-icon style="font-size:5rem;"> mdi-file-document-box-search</v-icon>
      </v-card-text>
      <v-card-text class="text-center" >
        List Of Accepted Documents
        <li>PAN Card</li>
        <li> Aadhaar Card</li> 
        <li> Driving License</li> 
        <li>Passport</li>
        
      </v-card-text>
      
      <v-card-title>
       <v-select
        :items="items"
        prepend-icon="mdi-file-document"
        :menu-props="{ bottom: true, offsetY: true }"
        label="Select Document Type"
      ></v-select>
       <v-file-input  placeholder="Png,Jpg,Pdf accepted." show-size counter  label="Upload your documents"></v-file-input>

      </v-card-title>
      <v-card-actions>
        <v-row class="justify-center">
        <v-btn color="primary" rounded class="mb-2 ml-2 login" > Upload </v-btn>
        
        <v-btn color="primary" rounded outlined class=" mb-4 login"  > Save </v-btn>
        </v-row>
        </v-card-actions>
      

    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  components: {
  },
  computed: {
    ...mapState('auth', {
      basePackExpiry: ({ profile }) => profile && profile.basePlan ? profile.basePlan.end_DATE : null,
      accountNo: state => state.accountNo,
      email: state => state.email,
      mobile: state => state.mobile,
      serialNo: ({ serialNo }) => serialNo,
      serialNoType: ({ serialNoType }) => serialNoType,
      walletBalance: ({ walletBalance }) => walletBalance,
      name: ({ userInfo }) => userInfo ? userInfo.firstname + ' ' + userInfo.lastname : ''
    }),
    ...mapGetters('auth', ['monthlyCost'])
  },
  data() {
    return {
      items: ['PAN Card', 'Aadhaar Card', 'Driving License', 'Passport'],
      Monthly_cost: 200,
      current_balance: 400,
      LCO_Name: "sai cable",
      Set_TOP_BOX_NUM: 8738945
    };
  }
};
</script>
<style scoped>
  .rupee {
    margin-right: 5px;
  }
</style>